"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import Util from '@baifendian/adherev-util';
var adherev_util_dict_1 = __importDefault(require("@baifendian/adherev-util-dict"));
var dict_flow_config_js_1 = __importDefault(require("./dict/dict.flow.config.js"));
var dict_form_config_js_1 = __importDefault(require("./dict/dict.form.config.js"));
var dict_gis_config_js_1 = __importDefault(require("./dict/dict.gis.config.js"));
var dict_locals_config_js_1 = __importDefault(require("./dict/dict.locals.config.js"));
var dict_mime_config_js_1 = __importDefault(require("./dict/dict.mime.config.js"));
var dict_moment_config_js_1 = __importDefault(require("./dict/dict.moment.config.js"));
var dict_normal_config_js_1 = __importDefault(require("./dict/dict.normal.config.js"));
function initDict(dict) {
    var _a, _b;
    (_a = dict === null || dict === void 0 ? void 0 : dict.initStatic) === null || _a === void 0 ? void 0 : _a.call(dict);
    (_b = dict === null || dict === void 0 ? void 0 : dict.initRemote) === null || _b === void 0 ? void 0 : _b.call(dict);
}
/**
 * initBasicDict
 * Resource提供的字典命名规范 Resource${业务分组}${实际业务名称}
 */
function initBasicDict() {
    [dict_flow_config_js_1.default, dict_form_config_js_1.default, dict_gis_config_js_1.default, dict_locals_config_js_1.default, dict_mime_config_js_1.default, dict_moment_config_js_1.default, dict_normal_config_js_1.default].forEach(function (dict) { return initDict(dict); });
    /*if (typeof require === 'undefined') {
      // vite
      // @ts-ignore
      const modules = import.meta.glob('./dict/!*.js', { eager: true });
  
      for (const path in modules) {
        const dict = modules[path]();
  
        if (dict && Util.isObject?.(dict)) {
          if ('initStatic' in dict && Util.isFunction?.(dict.initStatic)) {
            dict.initStatic();
          }
  
          if ('initRemote' in dict && Util.isFunction?.(dict.initRemote)) {
            dict.initRemote();
          }
        }
      }
    }
    else {
      console.log('webpack');
      // webpack
      // @ts-ignore
      const requireComponent = require?.context?.('./dict', false, /.*\.(js)$/) || {};
  
      requireComponent?.keys?.()?.forEach?.((path) => {
        const dict = requireComponent(path).default;
  
        if (dict && Util.isObject?.(dict)) {
          if ('initStatic' in dict && Util.isFunction?.(dict.initStatic)) {
            dict.initStatic();
          }
  
          if ('initRemote' in dict && Util.isFunction?.(dict.initRemote)) {
            dict.initRemote();
          }
        }
      });
    }*/
}
// 初始化一些基本的字典配置
initBasicDict();
var Resource = {
    Dict: adherev_util_dict_1.default,
};
exports.default = Resource;
